import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { Ams } from 'src/app/amsconfig';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private http: HttpClient) {}

  search(val: string) {
    if (!val || val.trim() === '') return of([]);
    const encodedQuery = encodeURIComponent(val.trim());
    return this.http.get<any[]>(`${Ams.Config.BASE_URL}/api/search?q=${encodedQuery}`);
  }
}
